import { render, staticRenderFns } from "./setting-system-index.vue?vue&type=template&id=40612dac&"
import script from "./setting-system-index.vue?vue&type=script&lang=js&"
export * from "./setting-system-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports